<template>
    <b-table
        id="municipios"
        :items="municipios"
        :fields="fields"
        striped
        small
        responsive="sm"
        :busy="configTable.load"
        :per-page="configTable.perPage"
        :current-page="configTable.currentPage"
        show-empty
        > 
        <div slot="table-busy" class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong> Carregando...</strong>
        </div>
        <template slot="empty">
            <p class="my-auto">Nenhum município encontrado.</p>
        </template>
        <template slot="excluir" slot-scope="row">
            <i class="fa fa-times" style="cursor: pointer" @click.prevent="excluir(row.item)" />
      </template>
    </b-table>
</template>

<script>
export default {
    props: ['municipios', 'fields', 'configTable'],
    methods: {
        excluir(item) {
            this.$emit('excluir', item)
        },
    }
       

}
</script>

<style scoped>

.no-line {
    white-space: nowrap;
}

</style>
